// Shared CSV download helper - previously duplicated (with slightly
// different escaping) between TimeEntries.js and TelegramMessages.js.

const escapeCsvField = (value) => {
  const str = String(value ?? '');
  return `"${str.replace(/"/g, '""')}"`;
};

export const downloadCsv = (filename, headers, rows) => {
  const csvContent = [headers.join(','), ...rows.map((row) => row.map(escapeCsvField).join(','))].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
